import React from "react";
import { Text, StyleSheet, TouchableHighlight } from "react-native";
import { COLORS as DEFAULT_COLORS } from "../theme/colors";
import { COLORS as APP_COLORS } from "../../theme/colors";

let COLORS = { ...DEFAULT_COLORS, ...APP_COLORS };

/**
 * PrimaryButton Component
 * Renders a button with a primary color and onPress functionality.
 * @param {string} title - The text to display on the button.
 * @param {function} onPress - The function to execute when the button is pressed.
 * @returns {JSX.Element} A styled button component.
 */

const Button = ({ title, onPress, theme, accessibilityLabel, testID }) => {
  // Merge theme colors if provided
  theme?.colors && (COLORS = { ...COLORS, ...theme.colors });

  return (
    <TouchableHighlight
      style={[styles.button]}
      testID={testID}
      onPress={onPress}
      underlayColor={COLORS.primaryVariant}
      accessible={true}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
    >
      <Text style={styles.buttonText} maxFontSizeMultiplier={1.2}>
        {title}
      </Text>
    </TouchableHighlight>
  );
};

const styles = StyleSheet.create({
  button: {
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 14,
    borderRadius: 12,
    borderWidth: 1,
    minWidth: 120,
    paddingHorizontal: 24,
    marginHorizontal: 8,
    backgroundColor: COLORS.primary,
    borderColor: COLORS.border,
  },
  buttonText: {
    color: COLORS.onPrimary,
    fontWeight: "bold",
    fontSize: 16,
  },
});

export default Button;
